import { FC, MouseEventHandler, ReactNode } from 'react'

interface RowButtonProps {
    onClick: MouseEventHandler
    children: ReactNode
}

export const RowButton: FC<RowButtonProps> = ({ children, onClick }) => {
    return (
        <a
            style={{
                fontWeight: 'bold',
                paddingTop: '8px',
                textDecoration: 'none'
            }}
            onClick={onClick}
        >
            {children}
        </a>
    )
}

export default RowButton
